import { StyleSheet, View } from "react-native";

import { useCustomTheme } from "@luna-restaurant/ui";

type WeeklyGridLoadingSkeletonProps = {
  weekCount: number;
};

export const WeeklyGridLoadingSkeleton = ({
  weekCount,
}: WeeklyGridLoadingSkeletonProps) => {
  const { colors } = useCustomTheme();

  return (
    <View style={styles.container}>
      {Array.from({ length: weekCount }).map((_, weekIndex) => (
        <View key={`loading-week-${weekIndex}`} style={styles.week}>
          <View style={styles.weekHeader}>
            <View
              style={[
                styles.loadingBlock,
                styles.weekBadge,
                { backgroundColor: colors.border },
              ]}
            />
            <View
              style={[
                styles.loadingBlock,
                styles.weekDownload,
                { backgroundColor: colors.border },
              ]}
            />
          </View>
          <View style={styles.weekGrid}>
            {Array.from({ length: 5 }).map((__, dayIndex) => (
              <View
                key={`loading-day-${weekIndex}-${dayIndex}`}
                style={[
                  styles.dayCard,
                  {
                    backgroundColor: colors.border,
                  },
                ]}
              />
            ))}
          </View>
        </View>
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    position: "relative",
    gap: 40,
    marginBottom: 20,
  },
  week: {
    width: "100%",
  },
  weekHeader: {
    flexDirection: "row",
    alignItems: "center",
    gap: 24,
    marginLeft: 14,
    marginBottom: 24,
  },
  loadingBlock: {
    borderRadius: 8,
    opacity: 0.22,
  },
  weekBadge: {
    width: 150,
    height: 20,
  },
  weekDownload: {
    width: 280,
    height: 16,
  },
  weekGrid: {
    flexDirection: "row",
    gap: 8,
    alignItems: "stretch",
  },
  dayCard: {
    flex: 1,
    minHeight: 400,
    borderRadius: 4,
    opacity: 0.18,
  },
});
